import { useTranslation } from 'react-i18next';
import { SidebarLayoutHeader } from '~/layout/components/sidebar-layout-header/SidebarLayoutHeader';
import { StandardHeader } from '~/layout/components/standard-header/StandardHeader';

export interface MealsHeaderProps {}

export interface MealsHeaderBodyProps {
  className?: string;
}

const MealsHeaderBody = ({ className }: MealsHeaderBodyProps) => {
  const { t } = useTranslation('meal');

  return (
    <StandardHeader
      className={className}
      subtitle={t('subtitle')}
      title={t('title')}
    />
  );
};

export const MealsHeader = Object.assign(
  ({}: MealsHeaderProps) => {
    return (
      <SidebarLayoutHeader>
        <MealsHeaderBody />
      </SidebarLayoutHeader>
    );
  },
  { Body: MealsHeaderBody },
);
